import api from "@/lib/api";

let unread = 0;
let request = null;
let lastFetchedAt = 0;
const CACHE_MS = 750;
const listeners = new Set();

function notify() {
  listeners.forEach((listener) => {
    try { listener(unread); } catch {}
  });
}

export function subscribeMessageUnread(listener) {
  listeners.add(listener);
  listener(unread);
  return () => listeners.delete(listener);
}

export async function refreshMessageUnread({ force = false } = {}) {
  const now = Date.now();
  if (!force && now - lastFetchedAt < CACHE_MS) return unread;
  if (request) {
    // A forced refresh can happen while the initial request is still in flight
    // (for example, immediately after opening a message). Wait for that request
    // and then perform the forced fetch so the badge cannot stay stale.
    if (force) {
      const pending = request;
      return pending.then(() => refreshMessageUnread({ force: true }));
    }
    return request;
  }

  request = api.get("/messages/unread-count")
    .then(({ data }) => {
      unread = Number(data?.count || 0);
      lastFetchedAt = Date.now();
      notify();
      return unread;
    })
    .catch(() => unread)
    .finally(() => {
      request = null;
    });

  return request;
}
